import type { FaireProductEntity } from "../../entity_types/product";

export const p_yvh46ygp4r: FaireProductEntity = {
  token: "p_yvh46ygp4r",
  type: "product",
  name: "Pumpkin Spice & Vanilla | 9oz Fall Candle",
  brandToken: "b_uckpbd2jy4",
  brandName: "Modern Roots Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/7bce81ef5ccb7b734d1628762ab3dd4a24eb8dae96a08cee7697818cea208cf9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c945a6744087120c04b15f71220a7b54c07dc706b0d76e19d046a959c9945042.png",
    "https://cdn.faire.com/fastly/18ae565b4f774e081ed450df59f1bb8870645abcab6f0ed45b6c37f2002e1086.png",
    "https://cdn.faire.com/fastly/cb0b8de2911afbecb708ff798baba648380285c499f70c6aa4775946b4c9850b.png",
    "https://cdn.faire.com/fastly/6f8bfb97f4cfc39168db9ed3d153cc26df27bbf4f814ed1361ad1e1c2b441b3e.png",
    "https://cdn.faire.com/fastly/4ab66c59e59bfcdc8cf92feec8f97584823e8b2ecb834a3c845fbb5b72bdfd1b.png",
    "https://cdn.faire.com/fastly/70240ce2185331e4d6ea12ed2b74bc682ed817bec5a4a81c702cd8360b3c024e.png",
  ],
  priceDollars: 11,
  description:
    "Cozy and inviting, this candle blends the warm, comforting scent of pumpkin spice with the smooth sweetness of vanilla. Perfect for autumn days or any time you want your space to feel like a warm hug.\n-----------------------------------\nOur candles at Modern Roots Candle Co. are hand-poured in small batches and tested to precision. All candles are made with 100% natural soy wax, cotton braided wick, and clean fragrances infused with essential oils and free of phthalates. This combination makes for a cleaner and longer burn time.\n\nSingle wick candles are great for bedrooms and bathrooms.\n\nOur labels are printed on estate #9 paper for a premium textured feel.\n\n9 oz. Candle Burn Time: Up to 45 Hours",
  tags: [],
  msrpDollars: 22,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:02.145Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
